import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { ClickableImageLinksAddon } from '../components/techdocs/ClickableImageLinks';

const clickableImageLinksAddon = AddonBlueprint.make({
  name: 'clickable-image-links',
  params: {
    name: 'ClickableImageLinks',
    location: TechDocsAddonLocations.Content,
    component: ClickableImageLinksAddon,
  },
});

export const techdocsClickableImageLinksModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [
    clickableImageLinksAddon,
    techdocsPlugin.getExtension('page:techdocs').override({
      params: {
        title: 'Volkswagen Documentation',
        loader: async () => {
          const { CustomTechDocsIndexPage } = await import('../components/techdocs/TechDocsIndexPage');
          return <CustomTechDocsIndexPage />;
        },
      },
    }),
  ],
});
